import BodyText from 'LuxKit/Typography/BodyText'

interface Props {
  offer: App.BundleOffer
}

function HotelBundleSearchTileMeta({ offer }: Props) {
  return <BodyText variant="medium">{offer.name}</BodyText>
}

export default HotelBundleSearchTileMeta
